import { supabase } from '@/lib/supabase'
import type { ScrapeJob } from '../types'

export async function getScrapeJobs(companyId: string, limit: number = 999): Promise<ScrapeJob[]> {
  const { data, error } = await supabase
    .from('scrape_jobs')
    .select('*')
    .eq('company_id', companyId)
    .order('created_at', { ascending: false })
    .limit(limit)

  if (error) throw error
  return data || []
}
